import { Component, computed, input, output } from '@angular/core';
import { NgClass, NgStyle } from '@angular/common';
import { LineOrientation } from '../../../../../models/interfaces';
import { TableOverlayLine } from '../../../../../table-overlay/table-overlay';
import { mapValues } from '@ps-gui/shared-utils';
import { Dimension2d, WordRect } from '@ps-gui/claims-terminal-shared';

@Component({
  selector: 'ct-extraction-table-overlay-line',
  imports: [NgClass, NgStyle],
  templateUrl: './table-overlay-line.component.html',
})
export class TableOverlayLineComponent {
  readonly line = input.required<TableOverlayLine>();
  readonly hideEventtarget = input.required<boolean>();
  readonly tableRect = input.required<WordRect>();
  readonly dimension = input.required<Dimension2d>();

  selected = output<void>();

  delete = output<void>();

  protected readonly isDeletable = computed(() => !this.line().isBoundary);

  protected readonly getStretchStyle = computed(() => {
    const line = this.line();
    const dimension = this.dimension();
    const table = this.tableRect();
    const offsetPivot = line.orientation === LineOrientation.VERTICAL ? 'left' : 'top';
    const stretch =
      line.orientation === LineOrientation.VERTICAL
        ? {
            top: table.y[0] * dimension.height,
            height: (table.y[1] - table.y[0]) * dimension.height,
          }
        : {
            left: table.x[0] * dimension.width,
            width: (table.x[1] - table.x[0]) * dimension.width,
          };
    return {
      [offsetPivot]: `${line.offset() * (line.orientation === LineOrientation.VERTICAL ? dimension.width : dimension.height)}px`,
      ...mapValues(stretch, (_, value) => `${value}px`),
    };
  });

  protected readonly getButtonStyleClasses = computed(() => {
    switch (this.line().orientation) {
      case LineOrientation.VERTICAL:
        return ['top-0 -left-2'];
      case LineOrientation.HORIZONTAL:
        return ['left-0', '-top-1.5'];
      default:
        return [];
    }
  });
}
